import { render, staticRenderFns } from "./LeonidaAccettazionePazienteViewComponent.vue?vue&type=template&id=4e1316d4"
import script from "./LeonidaAccettazionePazienteViewComponent.vue?vue&type=script&lang=js"
export * from "./LeonidaAccettazionePazienteViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports